import { Box, Button, Container, Typography, Paper, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EmailIcon from '@mui/icons-material/Email';
import NavBar from "./nav-bar";
import theme from "../../theme";
import { useTranslation } from "react-i18next";

export default function Confirmation() {
    const { t } = useTranslation();
    
    return (
        <NavBar showLinks={true} showIcon={true}>
            <Container maxWidth="md" sx={{ py: 8, minHeight: '100vh' }}>
                <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    minHeight: '80vh' 
                }}>
                    <Paper 
                        elevation={8}
                        sx={{ 
                            padding: { xs: 4, md: 6 }, 
                            borderRadius: 4,
                            textAlign: 'center',
                            maxWidth: 600,
                            width: '100%',
                            background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(248,250,252,0.95) 100%)'
                        }}
                    >
                        <Stack spacing={3} alignItems="center">
                            <CheckCircleIcon 
                                sx={{ 
                                    fontSize: 80, 
                                    color: theme.palette.success.main,
                                    filter: 'drop-shadow(0 4px 8px rgba(76, 175, 80, 0.3))'
                                }} 
                            />
                            
                            <Typography 
                                variant="h3" 
                                fontWeight="bold" 
                                color="primary.main"
                                sx={{ 
                                    fontSize: { xs: '1.8rem', md: '2.5rem' },
                                    lineHeight: 1.2,
                                    mb: 2
                                }}
                            >
                                {t('confirmation.thankYou')}
                            </Typography>
                            
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                <EmailIcon sx={{ color: theme.palette.primary.main, fontSize: 28 }} />
                                <Typography 
                                    variant="h6" 
                                    color="text.primary"
                                    sx={{ 
                                        fontSize: { xs: '1.1rem', md: '1.3rem' },
                                        fontWeight: 500
                                    }}
                                >
                                    {t('confirmation.emailSent')}
                                </Typography>
                            </Box>
                            
                            <Typography 
                                variant="body1" 
                                color="text.secondary"
                                sx={{ 
                                    fontSize: { xs: '0.95rem', md: '1.1rem' },
                                    lineHeight: 1.6,
                                    mb: 3,
                                    maxWidth: 400
                                }}
                            >
                                {t('confirmation.instructions')}
                            </Typography>
                            
                            <Button
                                component={Link}
                                to="/"
                                variant="contained"
                                size="large"
                                sx={{
                                    px: 4,
                                    py: 1.5,
                                    fontSize: '1.1rem',
                                    fontWeight: 600,
                                    borderRadius: 3,
                                    textTransform: 'none',
                                    boxShadow: 3,
                                    '&:hover': {
                                        boxShadow: 6,
                                        transform: 'translateY(-2px)',
                                    },
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                {t('confirmation.backHome')}
                            </Button>
                        </Stack>
                    </Paper>
                </Box>
            </Container>
        </NavBar>
    );
}